import { DeviceManager } from '@/service/device'
import { DevicePid } from './define'
import {
  AmberDeviceList,
  HE2MouseDeviceList,
  HE3SEMouseDeviceList,
  He6UltraDeviceList,
  JingTaiDeviceList,
  JingTaiV2DeviceList,
  JingTaiMer68Devices,
  JingTaiMg75Devices,
  QMKDeviceList,
  RoYuanDevice24GList,
  RoYuanDeviceList,
  RoYuanDeviceList_0005,
  WitmodDevicesList,
  Fe87v2DeviceList,
} from './device_vendor'
import { HuoChaiRenDevices, ZhiHuiWuXian_Device } from '@hid/define/define'
//不支持宏录制的pid
const macroType1Pids = [
  DevicePid.IROKFe75Pro,
  DevicePid.IROKFe98Pro,
  DevicePid.IROKAl87Rgb,
  DevicePid.IROKAl87Pro,
  ...QMKDeviceList,
  DevicePid.IYXMu68Pro,
  DevicePid.IYXMu68Pro_cyan,
  DevicePid.IYXMu68_ULTRA,
  DevicePid.IROKNd63,
  DevicePid.IROKNd63_cyan,
  DevicePid.IROKNa87Pro,
  ...Fe87v2DeviceList,
  DevicePid.CarotmasMer68SESelfDev,
  //   DevicePid.IROKMG63,
  //   DevicePid.IROKRA68_1,
]

const macroType2Pids = [
  DevicePid.IROKAl87,
  DevicePid.IROKHe3SE_Wireless,
  DevicePid.IROKHe3SE_Wireless_24g,
  DevicePid.IYXMu68Pro,
  DevicePid.IYXMu68Pro_cyan,
  DevicePid.IYXMu68_ULTRA,
  DevicePid.IROKNd63,
  DevicePid.IROKNd63_cyan,
  DevicePid.IROKNa87Pro,
  ...Fe87v2DeviceList,
  DevicePid.CarotmasMer68SESelfDev,
]

const macroType3Pids = [
  ...QMKDeviceList,
  DevicePid.IROKHe3SE_Wireless,
  DevicePid.IROKHe3SE_Wireless_24g,
  DevicePid.IYXMu68Pro,
  DevicePid.IYXMu68Pro_cyan,
  DevicePid.IYXMu68_ULTRA,
  DevicePid.IROKNd63,
  DevicePid.IROKNd63_cyan,
  DevicePid.IROKNa87Pro,
  ...Fe87v2DeviceList,
  DevicePid.CarotmasMer68SESelfDev,
  ...HuoChaiRenDevices, // TODO TYPE==3:按下循环触发，松开停止  不生效 先屏蔽
]

// prettier-ignore
export enum speciaBehiver {
    FnConlictWithNormal,                    // fn层和普通层 冲突
    NotSupportModifier,                     // 不支持组合键
    NotSupportFnKey,                        // 不支持fn层改键
    NotEditDKSBottomTravel,                 // 禁止修改dks触底行程
    SyncDKSFirstAndEndTravel,               // 同步dks第一个和最后一个的触发行程

    ShowBattery,                            // 支持电量显示的设备

    // 特殊设备，
    // （1）有线情况下显示充电
    SpecialEquipment_WiredCharging,


    SupportSetDeadZone,                     // 支持设置死区的设备
    NotSurportMacroPlayOnce,                // 不支持宏 播放一次 的设备
    NotSurportMacroPlayStop,                // 不支持按下播放，再按停止的设备
    NotSurportMacroPlayLoop,                // 不支持按住循环播放的设备


    ReadWriteRateFromFW,                    // 回报率从固件获取
    ReadWriteRateFromSetOrReadPollingRate,  // 回报率从SetOrRead PollingRate 获取
    ProfilePollingRate,                     // 从存档中回报率的设备

    SupportKME,                             // 支持 kme
    SupportAxisKeysGroup,                   // 支持轴体分组的设备
    SupportHidCalibration,                  // hid协议需要首次校准的设备
    DevicesOfWitmod,                        // 睿联微的设备
    DevicesOfJingtai_V1,                       // 晶态的设备
    DevicesOfJingtai_V2,                    // 晶态固件版本是V2的设备
    DevicesOfHuoChaiRen,                    // 火柴人的设备
    DevicesOfZhihuiwuxian,                  // 智慧无限的设备

    DevicesOfSelfDev,                       // 自研设备机械轴
    DevicesOfSelfDevMix,                    // 自研设备混合轴(机械轴+磁轴)
    DevicesOfSelfDevMagnet,                 // 自研设备磁磁轴 目前一定是mer68se自研版本

    SupportAdvancedSetting,                 // 支持高级设置
    SupportFireKey,
    SupportGetDeviceStatus,                 // 支持获取设备状态
    SupportSleep,                           // 支持休眠的设备
    DevicesSwitchOfJingtaiTianqing,         // 晶泰方案天青轴的设备
    DevicesSwitchOfJingtaiZixin,            // 晶泰方案紫星轴的设备

    DeviceOfRoyuan,                         // Royuan 的设备
    DeviceOf24GCalibration,                 // Royuan 24G模式下的设备

    DeviceTravelAbove6800,                  // 校准时行程大于等于6800的设备

    Device_UnknownAxis,                     // 多种轴体,无法确认默认轴的设备

    DeviceHe3SE,                            // He3SE 的设备
    SupportEndDelayTime,                    // 支持松开触发（END）延迟功能的设备
    WiredShowChargingAndPower,              // 有线状态下显示电量和充电状态的设备
    SupportRippleControl,                   // 支持波纹控制
    SupportLineCorrection,                  // 支持直线矫正
    SupportLongDistance,                    // 支持长距离模式
    SupportHighPerformance,                 // 支持高性能模式

    SupportLocalUpdate,                     // 支持本地更新的设备 
    SupportMusicRhythmSupported,            // 支持音乐律动的设备
    SupportWinLock,                         // 支持设置win锁定的设备
    SupportLockKeyboardDevice,              // 支持设置锁定的键盘的设备
    SupportDirectionKeySwapDevice,          // 支持方向键和WASD对调的设备
    SupportKeyMode,                         // 支持Key模式切换的设备

    SupportSingleKeyDeadZone,               // 支持单键死区设置的设备   
    // 关闭出厂默认固定死区
    CloseDefaultFixedDeadZone,              // 关闭出厂默认固定死区
}

// prettier-ignore
const mapSpecial: Map<speciaBehiver, DevicePid[]> = new Map<speciaBehiver, DevicePid[]>(
    [
        [speciaBehiver.FnConlictWithNormal, [
            // DevicePid.IROKNa87Pro,
            // DevicePid.IYXMu68Pro,
            // DevicePid.IYXMu68Pro_cyan,
            // DevicePid.IYXMu68_ULTRA,
            // DevicePid.IYXPolar75,
            // DevicePid.IROKNd63,
            // DevicePid.IROKNd63_cyan,
            // ...Mg75Devices, ...Mer68Devices
            ...JingTaiDeviceList,
            ...JingTaiV2DeviceList,
            ...Fe87v2DeviceList,
            DevicePid.CarotmasMer68SESelfDev,
            ...HuoChaiRenDevices
        ]],
        [speciaBehiver.NotSupportModifier, [
            // DevicePid.IROKQMKLi75,
            // DevicePid.IYXMu68Pro,
            // DevicePid.IYXMu68Pro_cyan,
            // DevicePid.IYXMu68_ULTRA,
            // DevicePid.IROKNa87Pro,
            // DevicePid.IYXPolar75,
            // DevicePid.IROKNd63,
            // DevicePid.IROKNd63_cyan,
            // ...Mg75Devices, ...Mer68Devices
            ...QMKDeviceList,
            ...JingTaiDeviceList,
            ...JingTaiV2DeviceList,
            ...Fe87v2DeviceList,
            DevicePid.CarotmasMer68SESelfDev,
            ...HuoChaiRenDevices,
        ]],
        [speciaBehiver.NotSupportFnKey, [
            DevicePid.IROKFe75Pro,
            DevicePid.IROKFe98Pro,
            DevicePid.IROKAl87Rgb,
            DevicePid.IROKAl87Pro,
            DevicePid.IROKAl87,
            ...QMKDeviceList,
            ...HE2MouseDeviceList,
            ...HE3SEMouseDeviceList,
            ...AmberDeviceList,
            ...He6UltraDeviceList,
            ...ZhiHuiWuXian_Device
        ]],
        [speciaBehiver.NotEditDKSBottomTravel, [
            DevicePid.IROKNa87Pro,
            DevicePid.IYXMu68Pro,
            DevicePid.IYXMu68Pro_cyan,
            DevicePid.IYXMu68_ULTRA,
            DevicePid.IYXPolar75,
            DevicePid.CarotmasMer68,
            DevicePid.CarotmasMer68Pro,
            DevicePid.IROKMg75,
            DevicePid.IROKMg75PRO,
            DevicePid.IROKNd63,
            DevicePid.IROKNd63_cyan,
        ]],
        [speciaBehiver.SyncDKSFirstAndEndTravel, [
            // DevicePid.IROKNa87Pro,
            // DevicePid.IYXMu68Pro,
            // DevicePid.IYXMu68Pro_cyan,
            // DevicePid.IYXMu68_ULTRA,
            // DevicePid.IYXPolar75,
            // DevicePid.IROKNd63,
            // DevicePid.IROKNd63_cyan,
            // ...Mg75Devices, ...Mer68Devices
            ...JingTaiDeviceList,
            ...HuoChaiRenDevices,
        ]],
        [speciaBehiver.DevicesOfJingtai_V1, [
            ...JingTaiDeviceList,
        ]],
        [speciaBehiver.DevicesOfJingtai_V2, [
            ...JingTaiV2DeviceList,
        ]],
        [speciaBehiver.ShowBattery, [
            ...HE2MouseDeviceList,
            DevicePid.IYXAmber358_Wired,
            DevicePid.IYXAmber358_24g8k,
            ...HE3SEMouseDeviceList,
            ...RoYuanDevice24GList,
            ...He6UltraDeviceList
        ]],
        [speciaBehiver.SupportSetDeadZone, [
            // DevicePid.IROKNa87Pro,
            // DevicePid.IYXMu68Pro,
            // DevicePid.IYXMu68Pro_cyan,
            // DevicePid.IYXMu68_ULTRA,
            // DevicePid.IYXPolar75,
            // DevicePid.IROKNd63,
            // DevicePid.IROKNd63_cyan,
            // ...Mg75Devices, ...Mer68Devices
            ...JingTaiDeviceList,
        ]],
        [speciaBehiver.NotSurportMacroPlayOnce, [
            ...macroType1Pids
        ]],
        [speciaBehiver.NotSurportMacroPlayStop, [
            ...macroType2Pids
        ]],
        [speciaBehiver.NotSurportMacroPlayLoop, [
            ...macroType3Pids
        ]],
        [speciaBehiver.ReadWriteRateFromFW, [
            // DevicePid.IROKNa87Pro,
            // DevicePid.IYXMu68Pro,
            // DevicePid.IYXMu68Pro_cyan,
            // DevicePid.IYXMu68_ULTRA,
            // DevicePid.IYXPolar75,
            // DevicePid.IROKNd63,
            // DevicePid.IROKNd63_cyan,
            // ...Mg75Devices, ...Mer68Devices
            ...JingTaiDeviceList,
            ...JingTaiV2DeviceList,
            DevicePid.CarotmasMer68SESelfDev,
        ]],
        [speciaBehiver.SupportKME, [
            // DevicePid.IROKNa87Pro,
            // DevicePid.IYXMu68Pro,
            // DevicePid.IYXMu68Pro_cyan,
            // DevicePid.IYXMu68_ULTRA,
            // DevicePid.IYXPolar75,
            // DevicePid.IROKNd63,
            // DevicePid.IROKNd63_cyan,
            // ...Mg75Devices, ...Mer68Devices
            ...JingTaiDeviceList,
            ...JingTaiV2DeviceList,
            ...RoYuanDeviceList,
            ...Fe87v2DeviceList,
            DevicePid.CarotmasMer68SESelfDev,
            ...HuoChaiRenDevices,
        ]],
        [speciaBehiver.SupportAxisKeysGroup, [
            // DevicePid.IROKNa87Pro,
            // DevicePid.IYXMu68Pro,
            // DevicePid.IYXMu68Pro_cyan,
            // DevicePid.IYXMu68_ULTRA,
            // DevicePid.IYXPolar75,
            // DevicePid.IROKNd63,
            // DevicePid.IROKNd63_cyan,
            // DevicePid.IROKNA87,
            // DevicePid.IROKNd75,
            // DevicePid.IYXMu68,
            // ...Mg75Devices, ...Mer68Devices
            ...WitmodDevicesList,
            ...JingTaiDeviceList,
            ...JingTaiV2DeviceList,
            ...HuoChaiRenDevices
        ]],
        [speciaBehiver.DevicesOfWitmod, [
            // DevicePid.IYXMu68,
            // DevicePid.IROKNd75,
            // DevicePid.IROKNA87
            ...WitmodDevicesList,
        ]],
        [speciaBehiver.SupportAdvancedSetting, [
            ...AmberDeviceList,
            ...He6UltraDeviceList,
        ]],
        [speciaBehiver.SupportFireKey, [
            //...AmberDeviceList
            ...He6UltraDeviceList
        ]],
        [speciaBehiver.SupportGetDeviceStatus, [
            ...HE3SEMouseDeviceList,
            ...AmberDeviceList,
            ...RoYuanDevice24GList,
            ...He6UltraDeviceList
        ]],
        [speciaBehiver.SpecialEquipment_WiredCharging, [
            DevicePid.IYXAmber358_Wired,
        ]],
        [speciaBehiver.SupportSleep, [
            DevicePid.IYXAmber358_24g8k,
            DevicePid.IROKHe3SE_Wireless_24g,
            ...RoYuanDevice24GList,
            ...He6UltraDeviceList,
        ]],
        [speciaBehiver.DevicesSwitchOfJingtaiZixin, [
            DevicePid.IYXMu68_ULTRA,
            DevicePid.IYXPolar75
        ]],
        [speciaBehiver.DevicesSwitchOfJingtaiTianqing, [
            DevicePid.IROKNd63_cyan,
            DevicePid.IYXMu68Pro_cyan,
        ]],
        [speciaBehiver.ProfilePollingRate, [
            DevicePid.IROKHe2,
            ...HE3SEMouseDeviceList
        ]],
        [speciaBehiver.ReadWriteRateFromSetOrReadPollingRate, [
            ...AmberDeviceList,
            ...He6UltraDeviceList,
            ...HuoChaiRenDevices,
            ...ZhiHuiWuXian_Device
        ]],
        [speciaBehiver.DeviceOfRoyuan, [
            ...RoYuanDeviceList
        ]],
        [speciaBehiver.DeviceOf24GCalibration, [
            ...RoYuanDevice24GList,
            DevicePid.IrokFe87V2IMC_24g,
            DevicePid.IrokFe87V2_24g
        ]],
        [speciaBehiver.DeviceTravelAbove6800, [
            ...RoYuanDeviceList_0005
        ]],
        [speciaBehiver.Device_UnknownAxis, [
            ...JingTaiMer68Devices,
            ...JingTaiMg75Devices,
            DevicePid.IYXPolar75
        ]],
        [speciaBehiver.DeviceHe3SE, [
            ...HE3SEMouseDeviceList
        ]],
        [speciaBehiver.SupportEndDelayTime, [
            DevicePid.IYXPolar75,
            ...JingTaiMg75Devices,
            ...JingTaiMer68Devices,
            ...JingTaiV2DeviceList,
            ...HuoChaiRenDevices,
        ]],
        [speciaBehiver.WiredShowChargingAndPower, [
            ...He6UltraDeviceList
        ]],
        [speciaBehiver.SupportRippleControl, [
            ...He6UltraDeviceList
        ]],
        [speciaBehiver.SupportLineCorrection, [
            ...He6UltraDeviceList
        ]],
        [speciaBehiver.SupportLongDistance, [
            ...He6UltraDeviceList
        ]],
        [speciaBehiver.SupportHighPerformance, [
            ...He6UltraDeviceList
        ]],
        [speciaBehiver.SupportLocalUpdate, [
            ...JingTaiV2DeviceList
        ]],
        [speciaBehiver.DevicesOfSelfDevMix, [
            DevicePid.IrokFe87V2IMC,
            DevicePid.IrokFe87V2IMC_24g,
        ]],
        [speciaBehiver.DevicesOfSelfDev, [
            DevicePid.IrokFe87V2,
            DevicePid.IrokFe87V2_24g,
            DevicePid.IrokFe87V2C18,
        ]],
        [speciaBehiver.DevicesOfSelfDevMagnet, [
            DevicePid.CarotmasMer68SESelfDev,
        ]],
        [speciaBehiver.SupportHidCalibration,[
            ...JingTaiV2DeviceList,
            ...JingTaiDeviceList,
            ...RoYuanDeviceList,
            DevicePid.IrokFe87V2IMC,
            DevicePid.IrokFe87V2IMC_24g,
            DevicePid.CarotmasMer68SESelfDev,
            ...HuoChaiRenDevices,

        ]],
        [speciaBehiver.DevicesOfHuoChaiRen, [
            ...HuoChaiRenDevices
        ]],
        [speciaBehiver.SupportWinLock,[
            // ...HuoChaiRenDevices
            // ...ZhiHuiWuXian_Device
        ]],
         [speciaBehiver.SupportLockKeyboardDevice,[
            ...HuoChaiRenDevices
        ]],
        [speciaBehiver.SupportDirectionKeySwapDevice,[
            ...HuoChaiRenDevices
        ]],
        [speciaBehiver.SupportKeyMode,[
            // ...HuoChaiRenDevices
            ...ZhiHuiWuXian_Device
        ]],
        [speciaBehiver.SupportSingleKeyDeadZone,[   
            ...HuoChaiRenDevices,
            ...RoYuanDeviceList,
            ...JingTaiV2DeviceList,
            DevicePid.IrokFe87V2IMC,
            DevicePid.IrokFe87V2IMC_24g,
            DevicePid.CarotmasMer68SESelfDev,
        ]],
        [speciaBehiver.DevicesOfZhihuiwuxian,[
            DevicePid.IROKFE87V2_MuYan,
        ]],
        [speciaBehiver.SupportMusicRhythmSupported,[
            ...JingTaiDeviceList,
            ...JingTaiV2DeviceList,
            ...HuoChaiRenDevices,
        ]],
        [speciaBehiver.CloseDefaultFixedDeadZone,[
            ...HuoChaiRenDevices,]
        ]
    ]
)

export const specialCheck = (behiver: speciaBehiver, device: DevicePid): boolean => {
  const pids = mapSpecial.get(behiver)
  if (pids) return pids.includes(device)
  return false
}

export const specialCheckCurrent = (behiver: speciaBehiver): boolean => {
  const device = DeviceManager.instance.state.currentPid
  const pids = mapSpecial.get(behiver)
  if (pids) return pids.includes(device)
  return false
}
